export default __webpack_public_path__ + "static/btut-3a9fbda68cfe8a13b2fcaced660ccf16.webm";